<template>
  <div class="flex items-center gap-1 text-h-s font-semibold" :class="{ 'flex-col !items-start': !isOneLined }">
    <div class="flex items-center gap-1">
      <template v-if="rating">
        {{ rating }}
      </template>
      <se-svg name="star-filled" :height="15" :width="15" class="text-warning-100" />
      <span
        class="cursor-pointer leading-[1]"
        :class="{ 'border-b': props.reviewsCount === null }"
        @click="emits('reviewsClicked')"
        >({{ new Intl.NumberFormat().format(feedbacks ? feedbacks : 0) }})
      </span>
    </div>
    <span v-if="props.isOneLined && props.sessionCountVisible">•</span>
    <div v-if="props.sessionCountVisible" class="flex items-center gap-1">
      <template v-if="props.advisor.total_sessions">
        {{ new Intl.NumberFormat().format(props.advisor.total_sessions) }} sessions since
        {{ new Date(props.advisor.created_at).getFullYear() }}
      </template>
      <template v-else> New Advisor </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { AdvisorService } from '@/src/modules/advisor/services/advisor.service';
import { usersStore } from '@/src/store/users';
import SeSvg from '@/src/ui-kit/svg/Svg';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    advisor: any;
    centered?: boolean;
    divider?: boolean;
    clickable?: boolean;
    isOneLined?: boolean;
    sessionCountVisible?: boolean;
    reviewsCount?: number | null;
  }>(),
  {
    centered: false,
    divider: false,
    clickable: false,
    isOneLined: true,
    sessionCountVisible: true,
    reviewsCount: null,
  }
);

const emits = defineEmits(['reviewsClicked']);
const users = usersStore();
const { userFeedBacksTotal } = storeToRefs(users);

const rating = computed(() => AdvisorService.getRating(props.advisor.accuracy));
const feedbacks = computed(() => (props.reviewsCount ? props.reviewsCount : userFeedBacksTotal.value));
</script>

<script lang="ts">
export default {
  name: 'SeAdvisorAccuracy',
};
</script>
